import React, { useState, ChangeEvent, useEffect } from "react";
import { Alert, Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  getUploadKeyAction,
  setUploadFileAction,
} from "../../../store/reducers/mmymSlice";
import { useSelector } from "react-redux";
import { getUploadFileKeyAction } from "../../../store/reducers/documentSlice";

interface FileUploaderProps {
  defaultImage?: string;
  onImageUpload: (image: string | null) => void;
  width?: number; // Dynamic width
  height?: number; // Dynamic height
  showUploadButton?: boolean; // Optional prop to control upload button visibility
  btnName?: string;
  page?: string;
  accept: string;
  odtFileName?: string;
  uploadFileName?: string;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  defaultImage,
  onImageUpload,
  width,
  height,
  btnName,
  showUploadButton = false,
  page = "",
  accept = "",
  odtFileName = "",
  uploadFileName = "",
}) => {
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const [fileError, setfileError] = useState("");
  const dispatch = useDispatch();
  const { imageUploadKey } = useSelector((state: any) => state?.mmym);
  const { userProfile } = useSelector((state: any) => state.user);
 
  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      event.target.value = "";
// for ODT file
    const isOdt = file?.name?.endsWith(".odt");
    const fileType =
      file?.type ||
      (isOdt
        ? "application/vnd.oasis.opendocument.text"
        : "application/octet-stream");
     console.log("isOdt", isOdt);
     console.log("page", page);
     console.log("file", file?.type);
     console.log("odtFileName", odtFileName);
      if (file?.type?.includes(accept) || isOdt) {
        if (file?.size > 5000000) {
          const size = file?.size / 1000;
          setfileError(
            `Filesize ${size} kb is too big, Maximum allowed is 5000 kb.`
          );
          setTimeout(() => {
            setfileError("");
          }, 3000);
        } else {
          const reader = new FileReader();
          reader.onloadend = () => {
            console.log("reader-", reader);
            const image = reader.result as string;
                        const finalFileName = uploadFileName ||
                          (isOdt && odtFileName
                            ? `${page}/${odtFileName}.odt`
                            : `${page}/${file?.name}`);
            if (file?.name) {
              dispatch(
                getUploadFileKeyAction({
                  fileName: finalFileName,
                  fileType,
                  ...(fileType === "application/pdf" ? { keepPublic: true } : {}),
                  ...(page === "templates" && odtFileName
                    ? { templatesName: odtFileName }
                    : {}),
                  // keepPublic: true,
                  body: file,
                  page,
                })
              );
            }
            setSelectedFile(image);
            dispatch(
              setUploadFileAction({
                url: image,
                key: "",
              })
            );
            onImageUpload(image);
          };
          reader.readAsDataURL(file);
        }
      } else if (file?.type) {
        setfileError(
          `You selected different format - ${file?.type}, Please select ${accept} only.`
        );
        setTimeout(() => {
          setfileError("");
        }, 3000);
      }
    }
  };
 
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      { (userProfile?.roles?.includes('TENANT') || userProfile?.roles?.includes("Admin") || userProfile?.roles?.includes('Owner')) && (
        <input
          accept={accept}
          style={{ display: "none" }}
          id={`raised-button-file-${odtFileName}`}
          type="file"
          onChange={handleImageUpload}
        />
      )}
   

      <label htmlFor={`raised-button-file-${odtFileName}`} style={{ cursor: "pointer" }}>
        {defaultImage && <img
          src={imageUploadKey?.url || selectedFile || defaultImage}
          alt="upload"
          style={{
            width: `${width}px`,
            height: `${height}px`,
            marginTop: "10px",
            objectFit: "contain",
          }}
        />}
      </label>
      {fileError && (
        <div style={{ padding: "0 20px" }}>
          <Alert severity={"error"}>{fileError}</Alert>
        </div>
      )}
      {showUploadButton &&
        (userProfile?.roles?.includes('TENANT') || userProfile?.roles?.includes("Admin") || userProfile?.roles?.includes('Owner')) && (
          <label htmlFor={`raised-button-file-${odtFileName}`}>
            <Button
              sx={{  textTransform: "capitalize", padding: "4px 16px" }}
              variant="contained"
              component="span"
            >
              {btnName ? btnName : "Upload File"}
            </Button>
          </label>
        )}
    </Box>
  );
};

export default FileUploader;
